import { useEffect } from "react";

export function useSeo(title, description) {
  useEffect(() => {
    document.title = `${title} — VidhFlow`;
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "description";
      document.head.appendChild(meta);
    }
    meta.content = description;
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.rel = "canonical";
      document.head.appendChild(canonical);
    }
    canonical.href = `https://vidhflow.com${window.location.pathname}`;
  }, [title, description]);
}
